import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Queue } from '../../classes/queue/queue';
import { LogService } from '../log/log.service';
import { SqlService } from '../sql/sql.service';

@Injectable({
  providedIn: 'root'
})
export class QueueService {
  private platformIsNative: boolean;

  private logTag = 'QueueService';

  constructor(private platform: Platform, private sqlService: SqlService, private logService: LogService) {
    this.platformIsNative = this.platform.is('cordova');
  }

  /**
   * Returns queue from local device or create empty one.
   */
  public getQueue(queueId: string): Promise<Queue> {
    return new Promise<Queue>((resolve) => {
      if (this.platformIsNative) {
        this.sqlService
          .getQueueById(queueId)
          .then((res) => {
            // Create queue object
            const queue = new Queue(queueId);
            this.logService.info(this.logTag, 'queue from sql');
            this.logService.object(res);
            // Add head and tail from response to queue
            queue.head = res.head;
            queue.tail = res.tail;
            resolve(queue);
          })
          .catch(() => {
            // Resolve empty queue when no local queue was found
            resolve(new Queue(queueId));
          });
      } else {
        // Resolve empty queue when in a web browser
        resolve(new Queue(queueId));
      }
    });
  }

  /**
   * Saves the queue to local device.
   * Never rejects, because failing to persist the queue may not stop the queued
   * requests from being sent, it only costs the ability to replay them after a restart.
   */
  public async saveQueue(queue: Queue): Promise<void> {
    try {
      await this.sqlService.saveQueue(queue.id, queue);
    } catch (err) {
      this.logService.error(this.logTag, 'Unable to save queue');
      this.logService.object(err);
    }
  }

  /**
   * Removes queue from local device.
   */
  public deleteSavedQueue(queueId: string): Promise<any> {
    return this.sqlService.deleteQueue(queueId);
  }
}
